module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAGCAYAAAAPDoR2AAAAXElEQVQYV2XMQQ5EUAAE0S4SmWDLdcZ5uA43wZbbSMzP2Eto+6+2Lym2uawye1eUpR/H/PneTtcYsVbCmLfA8EJ54D/lvUX32todYSwWUBNjwtUQpmJHqmI8oX4AUvkgCLj2l4gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/sibianxing.png
// module id = 8TpV
// module chunks = 1